import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    diffTime: null
  },
  getters: {
    diffTime: (state) => {
      if(state.diffTime === null)
        return 0
      else
        return state.diffTime
    }
  },
  mutations: {
    UPDATE_DIFFTIME(state, diff){
      console.log('UPDATE_DIFFTIME', diff)
      state.diffTime = diff
    }
  },
  actions: {
    updateDifftime({ commit }, payload) {
      commit('UPDATE_DIFFTIME', payload)
    }
  },
  modules: {
  }
})
